import { createContext, useContext } from "react";

/*
 * WP4.6a: true inside `GridPageLayoutV2` (the new-UI module screen). Holds no design-system code, so the classic
 * `GridPageLayout.tsx` may import it eagerly: its `GridPageHeaderLeft` (used inside module custom headers — Files,
 * Mailbox) switches to the restyled header only while this is true. Outside a V2 module screen it is false and
 * every classic path is unchanged.
 */
export const ModuleLayoutContext = createContext<boolean>(false);

export function useInModuleLayoutV2(): boolean {
  return useContext(ModuleLayoutContext);
}

/*
 * New UI: true inside the shell's page frame (`ClassicPageFrame page`, a classic page body in the new shell, plan-ds
 * §4.13). The classic `GridPageLayout` then drops its outer `#F0F5F9` page fill: classic draws it on a page of the
 * same colour, so it is invisible there, but on the shell's page colour it shows as a strip beside the card. False
 * everywhere else (settings sections, dialogs, the flag-off app), where nothing changes.
 */
export const ShellPageFrameContext = createContext<boolean>(false);

export function useInShellPageFrame(): boolean {
  return useContext(ShellPageFrameContext);
}
